import { all, call, put, takeLatest } from 'redux-saga/effects';

import api from 'api';

import { getDeepLinkError, getDeepLinkSuccess } from './actions';
import { GET_DEEP_LINK_REQUEST } from './actionTypes';
import { logDeepLinkError } from './helpers';

export function* getDeepLink() {
    try {
        const deepLink: { url: string } = yield call(api.user.deepLinks);

        yield put(getDeepLinkSuccess(deepLink.url));
    } catch (error: any) {
        logDeepLinkError(error);

        yield put(getDeepLinkError(error.error));
    }
}

export default function* watchDeepLink() {
    yield all([takeLatest(GET_DEEP_LINK_REQUEST, getDeepLink)]);
}
